module.exports = [{"url":"https://www.linkedin.com/in/alecjandorek/","icon":["fab","linkedin"]},{"url":"https://github.com/ajandorek","icon":["fab","github"]},{"url":"mailto:ajandorek@gmail.com","icon":"envelope"}]


//////////////////
// WEBPACK FOOTER
// ./src/utils/contact.json
// module id = 313
// module chunks = 35783957827783